import * as React from "react";
import { cn } from "@/shared/lib/utils";

import LeftIcon from "@/assets/icons/arrow/left2White.svg?react";
import RightIcon from "@/assets/icons/arrow/right2White.svg?react";

interface ITransparentArrowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  arrow: 'right' | 'left';
}

const TransparentArrowButton = React.forwardRef<HTMLButtonElement, ITransparentArrowButtonProps>(
  ({ className, arrow, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "group flex h-[44px] w-[44px] cursor-pointer items-center justify-center rounded-full border-[0.5px] shadow-glass transition-all duration-200 ease-linear",
          
          "border-white-50",
          
          "bg-white-20",
          "hover:bg-white-50",
          "active:bg-white-20",
          
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50",
          
          className
        )}
        {...props}
      >
        {arrow === 'left' ? (
          <LeftIcon className="h-auto w-[20px]" />
        ) : (
          <RightIcon className="h-auto w-[20px]" />
        )}
      </button>
    );
  }
);

TransparentArrowButton.displayName = "TransparentArrowButton";

export default TransparentArrowButton;